import {ReactElement} from "react";
import {Image} from "antd";
import IAuthentication from "../interfaces/IAuthentication";

interface IProps {
    auth: IAuthentication
    size?: number
    style?: any
}

export default function AuthIcon(props: IProps): ReactElement | null {
    return (
        <>
            {props.auth?.logo &&
                <Image preview={false} width={20} src={`${window.userprofile.url}/${window.userprofile.path.icon}/${props.auth?.logo}.png`}/>
            }
        </>
    )
}